import { Injectable } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { faro } from '@grafana/faro-web-sdk'

@Injectable()
export class HttpErrorReportingInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && this.shouldReport(error)) {
                    this.reportRequestFailure(request, error)
                }

                return throwError(error)
            })
        )
    }

    private reportRequestFailure(request: HttpRequest<unknown>, error: HttpErrorResponse): void {
        const status = String(error.status)
        const statusText = error.status === 0 ? 'Network request failed' : error.statusText || 'Unknown status'
        const requestUrl = this.getSafeUrl(request.url)
        const message = `HTTP request failed: ${request.method} ${requestUrl} (${status} ${statusText})`

        faro.api.pushError(new Error(message), {
            type: 'HttpErrorResponse',
            context: {
                operation: 'http_request',
                method: request.method,
                url: requestUrl,
                status,
                statusText
            }
        })
    }

    private shouldReport(error: HttpErrorResponse): boolean {
        return error.status === 0 || error.status === 429 || error.status >= 500
    }

    private getSafeUrl(url: string): string {
        return url.split('?')[0].split('#')[0]
    }
}
